import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=1f8de28e&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"
import style0 from "./Safety.vue?vue&type=style&index=0&id=1f8de28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8de28e",
  null
  
)

export default component.exports